<template>
  <Modal
    ref="modal"
    title="Kombinationsversand"
    class="modal-shipping-combined"
  >
    <template v-slot:content>
      <p class="u-text-dimmed">Bei dieser Option können Sie die <b>{{ $store.getters.getSelectedQty }} Präsente</b> auf die Versandoptionen "Direktversand an Beschenkte" (ein Präsent pro Adresse) und Großversand (mehrere Präsente pro Adresse) aufteilen.</p>

      <FlashMessage
        v-if="$parent.errors.length"
        type="error"
      >
        <p>{{ $parent.errors[0].message }}</p>
      </FlashMessage>

      <p>Zuordnung der Präsente nach Versandart:</p>

      <!-- individual shipping -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon">
            <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 31L2.31467 27.644C1.46364 26.5802 1 25.2584 1 23.896V17C1 16.4696 1.21071 15.9609 1.58579 15.5858C1.96086 15.2107 2.46957 15 3 15V15C3.53043 15 4.03914 15.2107 4.41421 15.5858C4.78929 15.9609 5 16.4696 5 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 30.8188V26.8188C11.0005 25.6323 10.6493 24.4723 9.99067 23.4854L8.468 21.2001C8.33808 20.9834 8.16554 20.7954 7.96083 20.6474C7.75611 20.4994 7.52349 20.3945 7.27704 20.339C7.03059 20.2835 6.77545 20.2787 6.52706 20.3247C6.27868 20.3707 6.04222 20.4667 5.832 20.6068V20.6068C5.45249 20.8596 5.17867 21.2427 5.06223 21.6836C4.9458 22.1245 4.99481 22.5928 5.2 23.0001L7 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27 31L29.6853 27.644C30.5364 26.5802 31 25.2584 31 23.896V17C31 16.4696 30.7893 15.9609 30.4142 15.5858C30.0391 15.2107 29.5304 15 29 15C28.4696 15 27.9609 15.2107 27.5858 15.5858C27.2107 15.9609 27 16.4696 27 17V22" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M21 30.8188V26.8188C20.9995 25.6323 21.3507 24.4723 22.0093 23.4854L23.532 21.2001C23.6619 20.9834 23.8345 20.7954 24.0392 20.6474C24.2439 20.4994 24.4765 20.3945 24.723 20.339C24.9694 20.2835 25.2246 20.2787 25.4729 20.3247C25.7213 20.3707 25.9578 20.4667 26.168 20.6068C26.5475 20.8596 26.8213 21.2427 26.9378 21.6836C27.0542 22.1245 27.0052 22.5928 26.8 23.0001L25 26.0001" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 2C10.3431 2 8.99997 3.34315 8.99997 5V12.4C8.98712 13.0762 9.24319 13.7298 9.71195 14.2173C10.1807 14.7048 10.8238 14.9863 11.5 15H21.5C22.1763 14.9867 22.8196 14.7053 23.2884 14.2177C23.7572 13.7301 24.0132 13.0763 24 12.4V4.6C24.0132 3.92371 23.7572 3.26987 23.2884 2.78228C22.8196 2.2947 22.1763 2.01331 21.5 2H12Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 2H19V9H14V2Z" stroke="#454F5B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>

          <div class="shipping__label">
            <slot v-if="selectionData.combined.international === false">
              <b>Direktversand an Beschenkte</b>
              <small v-if="$store.getters.isB2b">{{ splittedTaxSingleNet(5.9) }} pro Präsent, zzgl. MwSt.<br><span class="u-text-light">5,90 € zzgl. MwSt.</span></small>
              <small v-else>5,90 € pro Präsent, inkl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingleNet(5.9) }} zzgl. MwSt.</span></small>
            </slot>

            <slot v-else>
              <b>Direktversand an Beschenkte</b>

              <div class="shipping__option-duplex u-mt-3">
                <div class="shipping__option">
                  <div class="shipping__icon --has-multiple-flags">
                    <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
                  </div>

                  <div class="shipping__label">
                    Deutschland
                    <small v-if="$store.getters.isB2b">5,90 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(5.9) }} inkl. MwSt.</span></small>
                    <small v-else>5,90 € pro Präsent, inkl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(5.9) }} zzgl. MwSt.</span></small>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.single.de = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.single.de === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.eu - selectionData.combined.splitting.international.single.ch_uk - selectionData.combined.splitting.international.single.other - selectionData.combined.splitting.international.bulk.de - selectionData.combined.splitting.international.bulk.other)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.single.de === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>

              <div class="shipping__option-duplex">
                <div class="shipping__option">
                  <div class="shipping__icon">
                    <img src="@/assets/images/landing-page/flags/eu.svg" alt="Europe Flag">
                  </div>

                  <div class="shipping__label">
                    Europa
                    <small v-if="$store.getters.isB2b">13,50 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(13.5) }} € inkl. MwSt.</span></small>
                    <small v-else>{{ splittedTaxSingle(13.5) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">13,50 € zzgl. MwSt.</span></small>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.single.eu = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.single.eu === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.de - selectionData.combined.splitting.international.single.ch_uk - selectionData.combined.splitting.international.single.other - selectionData.combined.splitting.international.bulk.de - selectionData.combined.splitting.international.bulk.other)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.single.eu === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>

              <div class="shipping__option-duplex">
                <div class="shipping__option">
                  <div class="shipping__icon --has-multiple-flags">
                    <img src="@/assets/images/landing-page/flags/ch.svg" alt="Switzerland Flag">
                    <img src="@/assets/images/landing-page/flags/uk.svg" alt="United Kingdom Flag">
                  </div>

                  <div class="shipping__label">
                    Schweiz / UK
                    <small v-if="$store.getters.isB2b">35,00 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(35.0) }} inkl. MwSt.</span></small>
                    <small v-else>{{ splittedTaxSingle(35.0) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">35,00 € zzgl. MwSt.</span></small>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.single.ch_uk = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.single.ch_uk === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.de - selectionData.combined.splitting.international.single.eu - selectionData.combined.splitting.international.single.other - selectionData.combined.splitting.international.bulk.de - selectionData.combined.splitting.international.bulk.other)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.single.ch_uk === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>

              <div class="shipping__option-duplex">
                <div class="shipping__option">
                  <div class="shipping__icon --has-multiple-flags">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>

                  <div class="shipping__label">
                    Andere Länder
                    <small v-if="$store.getters.isB2b">45,00 € pro Präsent, zzgl. MwSt.<br><span class="u-text-light">{{ splittedTaxSingle(45.0) }} inkl. MwSt.</span></small>
                    <small v-else>{{ splittedTaxSingle(45.0) }} pro Präsent, inkl. MwSt.<br><span class="u-text-light">45,00 € zzgl. MwSt.</span></small>
                    <span class="shipping__additional_info">Lieferungen in die Türkei und nach Paraguay können aktuell nicht durchgeführt werden.</span>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.single.other = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.single.other === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.de - selectionData.combined.splitting.international.single.eu - selectionData.combined.splitting.international.single.ch_uk - selectionData.combined.splitting.international.bulk.de - selectionData.combined.splitting.international.bulk.other)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.single.other === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>
            </slot>
          </div>
        </div>

        <div
          v-if="selectionData.combined.international === false"
          class="shipping__select"
        >
          <FormSelect @change="(v) => selectionData.combined.splitting.national.single = parseInt(v)">
            <option value="0" :selected="selectionData.combined.splitting.national.single === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.national.bulk)" :key="i" :value="i" :selected="selectionData.combined.splitting.national.single === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /individual shipping -->

      <!-- bulk shipping -->
      <div class="shipping__option-duplex">
        <div class="shipping__option">
          <div class="shipping__icon">
            <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M12,12H2.625A1.914,1.914,0,0,0,.75,13.95V19.8a1.914,1.914,0,0,0,1.875,1.95h7.5A1.913,1.913,0,0,0,12,19.8V12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M4.5 12H8.25V17.25H4.5z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.25,12V4.2a1.913,1.913,0,0,0-1.875-1.95h-7.5A1.914,1.914,0,0,0,6,4.2V12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M9.75 2.25H13.5V7.5H9.75z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,12v7.8a1.914,1.914,0,0,0,1.875,1.95h7.5A1.913,1.913,0,0,0,23.25,19.8V13.95A1.913,1.913,0,0,0,21.375,12H12" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M15.75 12H19.5V17.25H15.75z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
          </div>

          <div class="shipping__label">
            <slot v-if="selectionData.combined.international === false">
              <b>Großversand, 1 oder mehrere Standorte</b>
              <small>{{ splittedTaxSingle($store.getters.getPricesShipping.bulkDe) }} pro Präsent inkl. MwSt.<br><span class="u-text-light">{{ $store.getters.getPricesShipping.bulkDe }} € zzgl. MwSt.</span></small>
            </slot>

            <slot v-else>
              <b>Großversand, 1+ Standorte</b>
              <small>Min. 3 Präsente pro Standort</small>

              <div class="shipping__option-duplex u-mt-3">
                <div class="shipping__option">
                  <div class="shipping__icon --has-multiple-flags">
                    <img src="@/assets/images/landing-page/flags/de.svg" alt="Deutschland Flag">
                  </div>

                  <div class="shipping__label">
                    Deutschland
                    <small>{{ splittedTaxSingle($store.getters.getPricesShipping.bulkDe) }} pro Präsent inkl. MwSt.<br><span class="u-text-light">{{ $store.getters.getPricesShipping.bulkDe }} € zzgl. MwSt.</span></small>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.bulk.de = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.bulk.de === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.de - selectionData.combined.splitting.international.single.eu - selectionData.combined.splitting.international.single.ch_uk - selectionData.combined.splitting.international.single.other - selectionData.combined.splitting.international.bulk.other)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.bulk.de === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>

              <div class="shipping__option-duplex">
                <div class="shipping__option">
                  <div class="shipping__icon --has-multiple-flags">
                    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#B7ECEC"/><path d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.66659 27.7333L7.99992 21H9.43992C9.74402 21.001 10.0443 20.9318 10.3172 20.7976C10.5901 20.6635 10.8283 20.4681 11.0133 20.2267C11.2037 19.9908 11.3357 19.7132 11.3982 19.4166C11.4608 19.1199 11.4522 18.8127 11.3733 18.52L10.3733 14.52C10.2685 14.0864 10.0208 13.7006 9.67005 13.4249C9.31935 13.1492 8.88604 12.9995 8.43992 13H1.33325" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M27.9999 7H22.5599C22.1137 6.9995 21.6804 7.14916 21.3297 7.42489C20.979 7.70062 20.7313 8.08636 20.6265 8.52L19.6265 12.52C19.5493 12.8137 19.5429 13.1216 19.6078 13.4183C19.6727 13.7149 19.8071 13.992 19.9999 14.2267C20.1848 14.4681 20.423 14.6635 20.6959 14.7976C20.9688 14.9318 21.2691 15.001 21.5732 15H23.6799L24.7199 21.3333C24.7979 21.7951 25.0354 22.2148 25.3912 22.5194C25.7469 22.824 26.1982 22.9941 26.6665 23H29.3332" stroke="#63A3A3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>

                  <div class="shipping__label">
                    Andere Länder
                    <small>Preis auf Anfrage</small>
                    <span class="shipping__additional_info">Lieferungen in die Türkei und nach Paraguay können aktuell nicht durchgeführt werden.</span>
                  </div>
                </div>

                <div class="shipping__select">
                  <FormSelect @change="(v) => selectionData.combined.splitting.international.bulk.other = parseInt(v)">
                    <option value="0" :selected="selectionData.combined.splitting.international.bulk.other === 0">0</option>
                    <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.international.single.de - selectionData.combined.splitting.international.single.eu - selectionData.combined.splitting.international.single.ch_uk - selectionData.combined.splitting.international.single.other - selectionData.combined.splitting.international.bulk.de)" :key="i" :value="i" :selected="selectionData.combined.splitting.international.bulk.other === i">{{ i }}</option>
                  </FormSelect>

                  Präsente
                </div>
              </div>
            </slot>
          </div>
        </div>

        <div
          v-if="selectionData.combined.international === false"
          class="shipping__select"
        >
          <FormSelect @change="(v) => selectionData.combined.splitting.national.bulk = parseInt(v)">
            <option value="0" :selected="selectionData.combined.splitting.national.bulk === 0">0</option>
            <option v-for="i in Math.max(0, boxQty - selectionData.combined.splitting.national.single)" :key="i" :value="i" :selected="selectionData.combined.splitting.national.bulk === i">{{ i }}</option>
          </FormSelect>

          Präsente
        </div>
      </div>
      <!-- /bulk shipping -->

      <p>
        <FormInput
          type="checkbox"
          v-model="selectionData.combined.international"
          :checked="selectionData.combined.international"
        >
          Internationaler Versand
        </FormInput>
      </p>
      <p class="u-text-dimmed" v-if="((selectionData.combined.splitting.national.bulk > 0 || selectionData.combined.splitting.national.single > 0) && selectionData.combined.international === false ) || (( selectionData.combined.splitting.international.bulk.de > 0 || selectionData.combined.splitting.international.single.de > 0 || selectionData.combined.splitting.international.single.ch_uk > 0 || selectionData.combined.splitting.international.single.eu > 0 || selectionData.combined.splitting.international.single.other > 0 ) && selectionData.combined.international === true)">Die angegebenen Kosten enthalten neben dem reinen Porto auch die Versandverpackung (z.B. Kartons, Füllmaterial) sowie deren Handling.</p>
      <Notice>
        <template v-slot:icon>
          <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g transform="matrix(1.3333333333333333,0,0,1.3333333333333333,0,0)"><path d="M9.000 7.500 A3.000 3.000 0 1 0 15.000 7.500 A3.000 3.000 0 1 0 9.000 7.500 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M12,.75A6.75,6.75,0,0,1,18.75,7.5c0,3.251-5.132,10.527-6.446,12.337a.377.377,0,0,1-.608,0C10.382,18.027,5.25,10.751,5.25,7.5A6.75,6.75,0,0,1,12,.75Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path><path d="M17.979,17.784c2.732.541,4.521,1.444,4.521,2.466,0,1.657-4.7,3-10.5,3s-10.5-1.343-10.5-3c0-1.02,1.781-1.921,4.5-2.463" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path></g></svg>
        </template>

        <p>Die Eingabe erfolgt mit Hilfe einer Excel-Vorlage, welche Sie nach der Bestellung per eMail erhalten.</p>
      </Notice>
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';
import Notice from '@/components/Composer/Notice';
import FormInput from '@/components/Common/FormInput';
import FormSelect from '@/components/Common/FormSelect';
import FlashMessage from '@/components/Composer/FlashMessage';

export default {
  name: 'ModalShippingCombined',
  props: {
    selectionData: {
      type: Object
    }
  },
  mixins: [logicMixin],
  components: {
    Modal,
    Button,
    Notice,
    FormInput,
    FormSelect,
    FlashMessage
  },
  methods: {
    submit () {
      this.selectionData.main.mode = 5;

      this.$refs.modal.close({
        submit: true
      });
    }
  },
  mounted() {
    if (this.selectionData.combined.splitting.national.single === 0 && this.selectionData.combined.splitting.national.bulk === 0) {
      this.selectionData.combined.splitting.national.single = this.boxQty;
    }
    if (this.selectionData.combined.splitting.international.single.de === 0 && this.selectionData.combined.splitting.international.single.eu === 0 && this.selectionData.combined.splitting.international.single.ch_uk === 0 && this.selectionData.combined.splitting.international.single.other === 0 && this.selectionData.combined.splitting.international.bulk.de === 0 && this.selectionData.combined.splitting.international.bulk.other === 0) {
      this.selectionData.combined.splitting.international.single.de = this.boxQty;
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalShippingCombined
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Combined Shipping Options
 * @since 2022-09-07
**/

$component: 'modal-shipping-combined';

.#{$component} {
  //…

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
